import MainHeader from "./MainHeader";
import { useEffect, useState, useMemo } from "react";
import MainSlider from "./MainSlider";
import styles from "../Styles/dashboardContainer.module.css";
import {
  ComponentsNames,
  EXCLUDE_ROUTES_FROM_LOGIN_REDIRECT,
  MainSliderDataForUser,
} from "../Utils/Constants";
import { Outlet, useNavigate } from "react-router-dom";
import { localUrlEnum, endpoints } from "../Utils/UrlEnum";
import { isMobile } from "../Utils/Utils";
import { getData } from "../Services/getData";

export default function DashboardContainer(props: any) {
  const navigate = useNavigate();
  const [hideSlider, setHideSlider]: any = useState(false);
  const [hasSchedulableInstructors, setHasSchedulableInstructors] =
    useState<any>(undefined);

  /**
   * Check if client has instructors with canSchedule enabled
   */
  useEffect(() => {
    const checkSchedulableInstructors = async () => {
      const clientId = localStorage.getItem("clientId");

      if (!clientId) {
        return;
      }

      try {
        const url = `${endpoints.client.instructors}/${clientId}`;
        const response = await getData(url);

        if (response?.data && Array.isArray(response.data)) {
          // Check if any instructor has canSchedule: true
          const hasSchedulable = response.data.some(
            (instructor: any) => instructor.canScheduleHours === true
          );
          setHasSchedulableInstructors(hasSchedulable);
        } else {
          setHasSchedulableInstructors(false);
        }
      } catch (error) {
        console.error("Error checking schedulable instructors:", error);
        setHasSchedulableInstructors(false);
      }
    };

    checkSchedulableInstructors();
  }, []);

  /**
   *
   */
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (
      !token &&
      !EXCLUDE_ROUTES_FROM_LOGIN_REDIRECT.includes(window.location.pathname)
    ) {
      navigate(localUrlEnum.login);
    }
  }, []);

  /**
   * Filter menu data based on schedulable instructors
   */
  const filteredMenuData = useMemo(() => {
    if (!hasSchedulableInstructors) {
      return MainSliderDataForUser.filter(
        (item) => item.path !== localUrlEnum.drivingSessionScheduling
      );
    }
    return MainSliderDataForUser;
  }, [hasSchedulableInstructors]);

  /**
   * Redirect to not found if accessing driving session scheduling without permission
   */
  useEffect(() => {
    if (
      hasSchedulableInstructors == false &&
      window.location.pathname === localUrlEnum.drivingSessionScheduling
    ) {
      navigate(localUrlEnum.pageNotFound);
    }
  }, [hasSchedulableInstructors, navigate]);

  /**
   *
   */
  const handleToggleSlider = () => {
    setHideSlider(!hideSlider);
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainHeader}>
        <MainHeader
          name={ComponentsNames?.MainHeader}
          shouldRenderSearchBar={props.shouldRenderSearchBar}
          setHideSlider={handleToggleSlider}
        />
      </div>
      {isMobile() ? (
        <div className={styles.secondContainer}>
          <div
            className={hideSlider ? styles.overlay : styles.overlayHide}
            onClick={handleToggleSlider}
          >
            <div
              className={hideSlider ? styles.mainSlider : styles.mainSliderHide}
            >
              <MainSlider
                name={ComponentsNames.MainSlider}
                data={filteredMenuData}
                setHideSlider={handleToggleSlider}
              />
            </div>
          </div>

          <Outlet />
        </div>
      ) : (
        <div className={styles.secondContainer}>
          <div
            className={hideSlider ? styles.mainSlider : styles.mainSliderHide}
          >
            <MainSlider
              name={ComponentsNames.MainSlider}
              data={filteredMenuData}
              setHideSlider={handleToggleSlider}
            />
          </div>

          <Outlet />
        </div>
      )}
    </div>
  );
}
